import createModel, { prop } from './lib/create_model';

export default createModel({
  modelName: 'MessagingConfiguration',
  properties: {
    agentCapacity: prop(Number),
    agentMaxCapacity: prop(Number),
    assignMailToConversationAssignee: prop(Boolean),
    autoAssignMessagingSessions: prop(Boolean).default(false),
    endMailSessionIntervalMins: prop(Number),
    endMessagingSessionIntervalMins: prop(Number),
    multipleTwitterChannels: prop(Boolean).default(false),
    routeNextMessagingSessionIntervalSecs: prop(Number),
    showPreview: prop(Boolean).default(true),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/messaging_configuration.js